import useGoToNavigation from "../../../../../util/useGotoNavigation";
import {IncomingUpdateType, InvHistoryType} from "../interface";
import React from "react";
import {useUser} from "../../../../../util/userContext/UserContext";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import ScanBarcodeInner from "../../../../../components/common/modal/inner/ScanBarcodeInner";
import {useModal} from "../../../../../hooks";
import {useUploadIncomingExcel} from "../../../incoming/create/hooks/useUploadIncomingExcel";
import FileUploadNoText from "../../../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import {useUpdateIncoming} from "../hooks/useUpdateIncoming";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import {SearchBusinessPartnerInner} from "../../../../../components/common/modal/inner/SearchBusinessPartnerInner";

interface PropsType {
    inventoryChangeDetail: InvHistoryType
    btnToggleEdit: () => any;
}

export default function InvHistoryIncomingEdit({inventoryChangeDetail, btnToggleEdit}: PropsType) {
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation()

    const {user} = useUser();
    const {mutateAsync: mutateAsyncUpdateIncoming} = useUpdateIncoming()
    const {mutateAsync: mutateAsyncUploadIncomingExcel} = useUploadIncomingExcel()

    const {register, handleSubmit, reset, getValues, control, setValue, watch} = useForm({
        defaultValues: inventoryChangeDetail,
    });

    const watchUpdateData = {
        ...inventoryChangeDetail,
        ...useWatch<InvHistoryType>({control}),
    };

    const onSubmit: SubmitHandler<InvHistoryType> = (submitData) => {
        if (getValues("inventoryChangeResList").length === 0) {
            handleModal({
                isOpen: true,
                contents: "품목을 추가해주세요.",
                type: "alert"
            })
        } else {
            const param: IncomingUpdateType = {
                memo: getValues("memo"),
                changeAt: getValues("changeAt"),
                accountName: getValues("accountName"),
                inventoryChangeRecordId: getValues("inventoryChangeRecordId"),
                updateEachIncomingReqList: getValues("inventoryChangeResList"),
            }

            mutateAsyncUpdateIncoming(param).then(res => {
                if (res.data.code === "0000") {
                    handleModal({
                        isOpen: true,
                        contents: "수정되었습니다.",
                        type: "alert",
                        closeAction: () => {
                            goToNavigation(`inventory/inv/history/${res.data.result?.inventoryChangeId}`, {}, false)
                            btnCancel()
                        }
                    });
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.msg,
                        type: "alert",
                    });
                }
            })
        }
    };

    const btnImportExcel = (file: File[]) => {
        if (file.length === 0) {
            handleModal({
                isOpen: true,
                contents: "파일을 선택해주세요.",
                type: "alert"
            })
        } else {
            const fd = new FormData()
            fd.append("excelFile", file.at(0) as File)

            mutateAsyncUploadIncomingExcel(fd).then((res: any) => {
                if (res.data.code === "0000") {
                    const list = res.data.result

                    if (
                        getValues("inventoryChangeResList").some(el => list.map((el2: any) => el2.inventoryId).includes(el.inventoryId))
                    ) {
                        handleModal({
                            isOpen: true,
                            contents: "중복된 품목은 추가할 수 없습니다.",
                            type: "alert",
                        });
                    } else {
                        setValue("inventoryChangeResList", [...getValues("inventoryChangeResList"), ...list.map((el: any) => ({
                            ...el,
                        }))])
                    }
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.message ?? res.data.msg,
                        type: "alert",
                    });
                }
            })
        }
    }

    const btnShowScanBarcodeInterface = () => {
        handleModal({
            isOpen: true,
            contents: <ScanBarcodeInner
                value={getValues("inventoryChangeResList")}
                setValue={(data) => setValue("inventoryChangeResList", data)}
            />,
            type: "",
            title: "바코드 스캔"
        });
    }

    // const btnGoToList = () => {
    //     goToNavigation(-1, {}, false)
    // }

    const btnCancel = () => {
        reset()
        btnToggleEdit()
    }

    const btnSearchAccountName = () => {
        handleModal({
            isOpen: true,
            contents: (
                <SearchBusinessPartnerInner
                    confirmCallback={(item) => {
                        if (setValue) {
                            setValue("accountName", item?.name, {
                                shouldDirty: true,
                            });
                        }
                    }}
                    modalDepth={1}
                />
            ), type: "",
            title: "상위 거래처 조회",
            modalSize: "xxl",
        });
    }

    const removeItem = (index: number) => {
        setValue("inventoryChangeResList", getValues("inventoryChangeResList").filter((_, i) => i !== index));
    };

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">입고 상세보기</h3>
            <div className="filter_toolbar">
                {/* NOTE: 목록 버튼이 필요 없어 보여서 삭제 */}
                {/*<button className="btn btn-outline-primary w-100px h-38px" onClick={btnGoToList}>*/}
                {/*    <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록*/}
                {/*</button>*/}
                <button className="btn btn-info w-100px h-38px" onClick={handleSubmit(onSubmit)}>저장
                </button>
                <button className="btn btn-outline-secondary w-100px h-38px"
                        onClick={btnCancel}>취소
                </button>
            </div>
        </div>

        <h5 className="subheading">입고 정보</h5>
        <table className="table table-bordered my_table">
            <tbody>
            <tr>
                <th style={{width: "16.66%"}}>입고번호</th>
                <td colSpan={3}>{inventoryChangeDetail.code}</td>
            </tr>
            <tr>
                <th style={{width: "16.66%"}}>생성자</th>
                <td style={{width: "33.3%"}}>{user?.userName ?? ""}</td>
                <th style={{width: "16.66%"}}>생성일자</th>
                <td>{inventoryChangeDetail.modAt}</td>
            </tr>
            <tr>
                <th>입고처</th>
                {/*<td style={{width: "33.3%"}}>{inventoryChangeDetail.accountName}</td>*/}
                <td className="p-4px">
                    <div className="input-group text_search">
                        <input type="text" className="form-control"
                               value={watchUpdateData.accountName}
                               {...register("accountName")}
                        />
                        <span className="input-group-text" onClick={btnSearchAccountName}><img
                            src={process.env.PUBLIC_URL + "/assets/images/icon_input_search.png"} alt=""/></span>
                    </div>
                </td>
                <th>입고일자</th>
                <td className="p-4px">
                    <input
                        type="datetime-local"
                        className="form-control"
                        max="9999-12-31"
                        value={watchUpdateData.changeAt}
                        {...register("changeAt")}
                    />
                </td>
            </tr>
            <tr>
                <th>메모</th>
                <td className="p-4px" colSpan={3}>
                    <input type="text" className="form-control"
                           value={watchUpdateData.memo}
                           {...register("memo")}
                    />
                </td>
            </tr>
            </tbody>
        </table>

        <div className="table_top mb-10px align-items-end">
            <h6 className="table_stats">입고 품목</h6>
            <div className="table_toolbar">
                <FileUploadNoText
                    addFileCallback={(file: File[]) => btnImportExcel(file)}
                    customRenderer={(onClick: any, disabled: any) =>
                        <button className="btn btn-outline-dark w-150px px-0"
                                onClick={onClick}
                                disabled={disabled}><img
                            src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt=""/>엑셀 가져오기
                        </button>

                    }
                    accept={".xlsx, .xls"}
                />
                <button className="btn btn-primary w-100px px-0 ms-40px" onClick={btnShowScanBarcodeInterface}>바코드 스캔
                </button>
            </div>
        </div>

        <table className="table table-bordered my_table mb-0">
            <thead>
            <tr>
                {/* 내부수정: 컬럼 사이즈 변경 */}
                <th style={{width: "3%"}}></th>
                <th style={{width: "8%"}}>벤더</th>
                <th style={{width: "8%"}}>카테고리</th>
                <th>품목</th>
                <th style={{width: "13%"}}>규격</th>
                <th style={{width: "5%"}}>단위</th>
                <th style={{width: "15%"}}>입고 수량</th>
                <th style={{width: "10%"}}>현재 재고</th>
            </tr>
            </thead>
            <tbody>
            {watchUpdateData.inventoryChangeResList.length !== 0
                ? watchUpdateData.inventoryChangeResList.map((el, idx) =>
                    <tr>
                        <td className="text-center">
                                        <button className="btn btn-link p-0" onClick={() => removeItem(idx)}>
                                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_btn_delete.png"}
                                                 alt=""/>
                                        </button>
                                    </td>
                        <td className="text-center">{el.vendor}</td>
                        <td className="text-center">{el.category}</td>
                        <td className="text-center">{el.newTxtNmItem}</td>
                        <td className="text-center">{el.newTxtStndItem}</td>
                        <td className="text-center">{el.inventoryUnit}</td>
                        <td className="p-4px">
                            <input type="text"
                                   className="form-control text-center"
                                   value={el.changeAmount}
                                   {...register(`inventoryChangeResList.${idx}.changeAmount`)}
                            />
                        </td>
                        <td className="text-center">{el.initialInventoryAmount}</td>
                    </tr>
                )
                : <EmptyTableRow colSpan={8} msg={"입고 품목을 추가해주세요."}/>
            }
            <tr className="blue">
                <td className="text-center" colSpan={5}>품목 수</td>
                <td className="text-end">{watchUpdateData.inventoryChangeResList.length}</td>
                <td className="text-center">총 수량</td>
                <td className="text-end">
                    {isNaN(watchUpdateData.inventoryChangeResList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0))
                        ? <>-</>
                        : <span className="requiredBlue">
                            {watchUpdateData.inventoryChangeResList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0) > 0 &&
                                <>+</>}
                            {watchUpdateData.inventoryChangeResList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0)}
                        </span>
                    }
                </td>
            </tr>
            </tbody>
        </table>
    </div>
}